// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/mapReviewAssets.test.ts
import { type AskPunttReviewFile } from "@mg/schemas/src/christo/askPunttReview";

import { type AssetFile } from "../../routes/ask-puntt/components/AssetViewerPane";

export function mapReviewFilesToAssets(
  files: readonly AskPunttReviewFile[],
): AssetFile[] {
  return files.map((file, index) => ({
    source: file.source,
    name: file.name ?? `Asset ${index + 1}`,
    type: file.type ?? "file",
    thumbnailUrl: file.thumbnailUrl ?? undefined,
  }));
}
